import { useFormContext, Controller } from 'react-hook-form';
import CustomNumber from '../customNumber';

export function RHFCustomNumber({ name, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <CustomNumber
          number={field.value || ''}
          onNumberChange={field.onChange}
          error={!!error}
          helperText={error?.message}
          {...other}
        />
      )}
    />
  );
}
